// Messaging.js (with message input area)

import React, { useState, useEffect, useRef, useMemo } from 'react';
import './Messaging.css';
import {
  getGroupsForUser,
  getUserLists,
  getListMembers, 
  showConfirmToast, 
  createGroupInFirestore,
  sendMessageToConversation,
  getOrCreateDirectConversation,
} from '../firebase/messagingUtils';
import { getAuth } from 'firebase/auth';
import { collection, arrayUnion, onSnapshot, getDocs, updateDoc, query,
   orderBy, where, doc, getDoc, setDoc, addDoc, deleteDoc, documentId,
   serverTimestamp, limit, startAt, endAt, } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import GroupChat from '../components/GroupChat';
import DirectChat from '../components/DirectChat';
import PageInfoButton from '../components/PageInfoButton';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { clearAllMissedCallNotifications } from '../utils/missedCallNotifications';




 
  const auth = getAuth();
  
  


const Messaging = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const normalizeSearchUser = (user = {}) => ({
    ...user,
    isFederal: user.isFederal === true,
  });
  const getLocationLabel = (user = {}) => (
    [user.city, user.stateProvince || user.state, user.country]
      .filter(Boolean)
      .join(', ') || 'Location not provided'
  );
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [groups, setGroups] = useState([]);
  const [showGroups, setShowGroups] = useState(true);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [newGroupName, setNewGroupName] = useState('');

  useEffect(() => {
    clearAllMissedCallNotifications();
  }, []);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [activeGroupId, setActiveGroupId] = useState(null);
  const [activeDirectId, setActiveDirectId] = useState(null);
  const { currentUser } = useUser();
  const [activeDMUserIds, setActiveDMUserIds] = useState([]);
  const [dmUnreadMap, setDmUnreadMap] = useState({});
  const [localGroupNames, setLocalGroupNames] = useState({});
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchFields, setSearchFields] = useState({});
  const [searchResults, setSearchResults] = useState([]);
  const [directoryOptions, setDirectoryOptions] = useState({});
  const [directoryFilters, setDirectoryFilters] = useState({});
  const [openDirectoryField, setOpenDirectoryField] = useState(null);
  const [activeDMUsers, setActiveDMUsers] = useState([]);
  const [userLists, setUserLists] = useState([]);
  const [listMembers, setListMembers] = useState({}); // { listId: [userObjects] }
  const [showCreateListModal, setShowCreateListModal] = useState(false);
  const [newListName, setNewListName] = useState('');
  const [openMenu, setOpenMenu] = useState({ listId: null, userId: null });
  const [expandedListId, setExpandedListId] = useState(null);
  const [selectedListId, setSelectedListId] = useState(null);
  const [searchContext, setSearchContext] = useState(null);
  const [selectedSearchUserIds, setSelectedSearchUserIds] = useState([]);
  const [selectAllResults, setSelectAllResults] = useState(false);
  const [searchUserMenuOpen, setSearchUserMenuOpen] = useState(null); 
  const [showSingleAddModal, setShowSingleAddModal] = useState(false);
  const [userToAddToList, setUserToAddToList] = useState(null);
  const [groupSelectorUser, setGroupSelectorUser] = useState(null);
  const [userGroups, setUserGroups] = useState([]);
  const [groupsLoading, setGroupsLoading] = useState(false);
  const [showCreateGroupModal, setShowCreateGroupModal] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [editingListId, setEditingListId] = useState(null);
  const [editedListName, setEditedListName] = useState('');
  const [addingToListLoading, setAddingToListLoading] = useState(false);
  const [addingToListId, setAddingToListId] = useState(null);
  const [showSearchInfo, setShowSearchInfo] = useState(false);
  const [dmConversations, setDmConversations] = useState([]);
  const [authUid, setAuthUid] = useState(null);
  const [pendingCallUserId, setPendingCallUserId] = useState(null);
  const [searchNoteMap, setSearchNoteMap] = useState({});
  const [openSearchNoteId, setOpenSearchNoteId] = useState(null);

  
 

	const infoBoxRef = useRef(null);


	useEffect(() => {
  const stop = getAuth().onAuthStateChanged(u => setAuthUid(u?.uid || null));
  return stop;
}, []);

	useEffect(() => {
  if (!location.state?.convoDeleted) return;

  toast.info('This conversation was deleted by the other user.');
  navigate(location.pathname, { replace: true, state: null });
}, [location.pathname, location.state, navigate]);


	useEffect(() => {
  const handleClickOutside = (event) => {
    if (infoBoxRef.current && !infoBoxRef.current.contains(event.target)) {
      setShowSearchInfo(false);
    }
  };

  if (showSearchInfo) {
    document.addEventListener('mousedown', handleClickOutside);
  } else {
    document.removeEventListener('mousedown', handleClickOutside);
  }

  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [showSearchInfo]);



  useEffect(() => {
    if (!showSearchModal) {
      setDirectoryFilters({});
      setOpenDirectoryField(null);
    }
  }, [showSearchModal]);



  useEffect(() => {
    if (currentUser?.uid) {
      setUserId(currentUser.uid);
    }
  }, [currentUser?.uid]);



	  const handleRemoveUserFromList = async (userId, listId) => {
  if (!currentUser?.uid || !userId || !listId) return;

  try {
    const memberRef = doc(db, 'users', currentUser.uid, 'userLists', listId, 'members', userId);
    await deleteDoc(memberRef);
    toast.success('User removed from list.');
    await fetchListsAndMembers(); // ✅ refresh UI
  } catch (err) {
    console.error('❌ Failed to remove user from list:', err);
    toast.error('Failed to remove user.');
  }
};


	const refreshGroupList = async () => {
  if (!userId) return;

  try {
    const q = query(
      collection(db, 'conversations'),
      where('isGroup', '==', true),
      where('members', 'array-contains', userId)
    );

    const snapshot = await getDocs(q);
    const groupList = [];

    for (const docSnap of snapshot.docs) {
      const data = docSnap.data();
      const groupId = docSnap.id;

      const latestMessageTime = data.lastMessageAt
  ? (data.lastMessageAt.toDate ? data.lastMessageAt.toDate() : new Date(data.lastMessageAt))
  : null;

      const viewDocRef = doc(db, 'conversations', groupId, 'views', userId);
      const viewDocSnap = await getDoc(viewDocRef);
      const lastViewed = viewDocSnap.exists() ? viewDocSnap.data().lastViewed?.toDate?.() : null;

     const lastSender = data.lastMessageSender || null;
const hasUnread = lastViewed && latestMessageTime
  ? latestMessageTime > lastViewed && lastSender !== userId
  : latestMessageTime && lastSender !== userId;


      groupList.push({
        id: groupId,
        ...data,
        hasUnread,
        createdAt: data.createdAt?.seconds
          ? new Date(data.createdAt.seconds * 1000)
          : new Date(data.createdAt),
      });
    }

    setGroups(groupList.sort((a, b) => b.createdAt - a.createdAt));
  } catch (err) {
    console.error('Failed to fetch groups:', err);
  }
};


const DIRECTORY_SEARCH_FIELDS = {
  country: {
    label: 'Country',
    optionType: 'countries',
    placeholder: 'Type to filter countries...',
  },
  stateProvince: {
    label: 'State / Province',
    optionType: 'stateProvinces',
    placeholder: 'Type to filter states or provinces...',
  },
  city: {
    label: 'City',
    optionType: 'cities',
    placeholder: 'Type to filter cities...',
  },
  lastName: {
    label: 'Last Name',
    optionType: 'lastNames',
    placeholder: 'Type to filter last names...',
  },
};

const getOptionLabel = (option) => option?.label || option?.display || '';

const loadDirectoryOptions = async (field, filterValue = '') => {
  const config = DIRECTORY_SEARCH_FIELDS[field];
  if (!config) return;

  try {
    const normalizedFilter = filterValue.trim().toLowerCase();
    const optionsRef = collection(
      db,
      'directoryOptions',
      config.optionType,
      'values'
    );
    const constraints = [orderBy('lower')];

    if (normalizedFilter) {
      constraints.push(startAt(normalizedFilter));
      constraints.push(endAt(`${normalizedFilter}\uf8ff`));
    }

    constraints.push(limit(25));

    const snap = await getDocs(query(optionsRef, ...constraints));
    const options = snap.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    })).sort((a, b) => (
      getOptionLabel(a).localeCompare(getOptionLabel(b))
    ));

    setDirectoryOptions((prev) => ({ ...prev, [field]: options }));
  } catch (err) {
    console.error('Failed to load directory options:', err);
    setDirectoryOptions((prev) => ({ ...prev, [field]: [] }));
  }
};

const handleAddSearchField = (field) => {
  if (field && !searchFields.hasOwnProperty(field)) {
    setSearchFields((prev) => ({ ...prev, [field]: null }));
    setDirectoryFilters((prev) => ({ ...prev, [field]: '' }));
    setOpenDirectoryField(field);
    void loadDirectoryOptions(field, '');
  }
};

const handleRemoveSearchField = (field) => {
  const updated = { ...searchFields };
  delete updated[field];
  setSearchFields(updated);
  setDirectoryFilters((prev) => {
    const next = { ...prev };
    delete next[field];
    return next;
  });
  if (openDirectoryField === field) {
    setOpenDirectoryField(null);
  }
};

const markConversationViewedBestEffort = (conversationId, viewerId) => {
  if (!conversationId || !viewerId) return;

  const viewRef = doc(db, 'conversations', conversationId, 'views', viewerId);
  void setDoc(viewRef, { lastViewed: serverTimestamp() }, { merge: true }).catch((err) => {
    if (err?.code !== 'permission-denied') {
      console.error('views write failed:', err);
    }
  });
};

const loadSearchResultNotes = async (resultUsers) => {
  const currentUid = currentUser?.uid;
  if (!currentUid || !Array.isArray(resultUsers) || resultUsers.length === 0) {
    setSearchNoteMap({});
    return;
  }

  try {
    const noteEntries = await Promise.all(
      resultUsers.map(async (resultUser) => {
        const noteRef = doc(db, 'users', currentUid, 'profileNotes', resultUser.id);
        const noteSnap = await getDoc(noteRef);
        if (!noteSnap.exists()) return null;

        const data = noteSnap.data();
        if (!data.text || !data.text.trim()) return null;
        return [resultUser.id, { id: noteSnap.id, ...data }];
      })
    );

    setSearchNoteMap(Object.fromEntries(noteEntries.filter(Boolean)));
  } catch (err) {
    console.error('Failed to load private note indicators:', err);
    setSearchNoteMap({});
  }
};


const handleRunSearch = async () => {
  const selectedFilters = Object.entries(searchFields)
    .filter(([, value]) => value?.lower);

  if (selectedFilters.length === 0) {
    toast.error('Please select at least one filter before searching.');
    return;
  }

  setHasSearched(true);

  try {
    const userCollection = collection(db, 'users');
    const queryFields = {};

    const addQueryField = (field, value) => {
      if (!value) return true;
      if (queryFields[field] && queryFields[field] !== value) {
        return false;
      }
      queryFields[field] = value;
      return true;
    };

    for (const [field, value] of selectedFilters) {
      let isCompatible = true;

      if (field === 'country') {
        isCompatible = addQueryField('countryLower', value.lower);
      } else if (field === 'stateProvince') {
        isCompatible =
          addQueryField('countryLower', value.countryLower) &&
          addQueryField('stateProvinceLower', value.lower);
      } else if (field === 'city') {
        isCompatible =
          addQueryField('countryLower', value.countryLower) &&
          addQueryField('stateProvinceLower', value.stateProvinceLower) &&
          addQueryField('cityLower', value.lower);
      } else if (field === 'lastName') {
        isCompatible = addQueryField('lastNameLower', value.lower);
      }

      if (!isCompatible) {
        setSearchResults([]);
        setSearchNoteMap({});
        toast.info('No users matched your search criteria.');
        return;
      }
    }

    const constraints = Object.entries(queryFields).map(([field, value]) => (
      where(field, '==', value)
    ));
    const q = constraints.length > 0
      ? query(userCollection, ...constraints)
      : userCollection;

    const snapshot = await getDocs(q);
    const allUsers = snapshot.docs.map((doc) =>
      normalizeSearchUser({ id: doc.id, ...doc.data() })
    );

    const filteredUsers = allUsers
      .filter((u) => u.id !== currentUser?.uid)
      .sort((a, b) => (
        (a.lastName || '').localeCompare(b.lastName || '') ||
        (a.firstName || '').localeCompare(b.firstName || '') ||
        (a.country || '').localeCompare(b.country || '') ||
        (a.stateProvince || a.state || '').localeCompare(
          b.stateProvince || b.state || ''
        ) ||
        (a.city || '').localeCompare(b.city || '')
      ));

    setSearchResults(filteredUsers);
    await loadSearchResultNotes(filteredUsers);
  } catch (err) {
    console.error('Failed to run user search:', err);
    setSearchNoteMap({});
  }

  setShowSearchModal(false);
};

const handleAddUserToList = async (userId, listId = selectedListId) => {
  if (!currentUser?.uid || !userId || !listId) return false;

  const memberRef = doc(db, 'users', currentUser.uid, 'userLists', listId, 'members', userId);
  const memberSnap = await getDoc(memberRef);

  if (memberSnap.exists()) {
    return false; // already in list
  }

  const userDoc = await getDoc(doc(db, 'users', userId));
  if (!userDoc.exists()) return false;

  await setDoc(memberRef, userDoc.data());
  return true;
};




const ensureDirectConversation = async (targetUserId) => {
  const currentUserId = auth.currentUser?.uid;
  if (!currentUserId || currentUserId === targetUserId) return null;

  try {
    const sortedKey = [currentUserId, targetUserId].sort().join('_');
    const existing = dmConversations.find(
      (c) =>
        c.dmKey === sortedKey ||
        (Array.isArray(c.members) && [...c.members].sort().join('_') === sortedKey)
    );

    let convoId = existing?.id;

    if (!convoId) {
      const [meSnap, otherSnap] = await Promise.all([
        getDoc(doc(db, 'users', currentUserId)),
        getDoc(doc(db, 'users', targetUserId))
      ]);
      const me = meSnap.exists() ? meSnap.data() : {};
      const other = otherSnap.exists() ? otherSnap.data() : {};

      convoId = await getOrCreateDirectConversation(currentUserId, targetUserId, {
        memberProfiles: {
          [currentUserId]: {
            firstInitialLastName: me.firstInitialLastName || null,
            agency: me.agency || null,
            rank: me.rank || null,
            city: me.city || null,
            stateProvince: me.stateProvince || me.state || null,
            country: me.country || null,
            avatarUrl: me.avatarUrl || null,
          },
          [targetUserId]: {
            firstInitialLastName: other.firstInitialLastName || null,
            agency: other.agency || null,
            rank: other.rank || null,
            city: other.city || null,
            stateProvince: other.stateProvince || other.state || null,
            country: other.country || null,
            avatarUrl: other.avatarUrl || null,
          }
        }
      });
    }

    return convoId;
  } catch (err) {
    console.error("Failed to ensure DM conversation:", err);
    return null;
  }
};

const openDirectConversation = async (targetUserId, { autoCall = false } = {}) => {
  setOpenMenu({ listId: null, userId: null });
  setSearchUserMenuOpen(null);

  const convoId = await ensureDirectConversation(targetUserId);
  const currentUserId = auth.currentUser?.uid;
  if (!convoId || !currentUserId) return;

  setCurrentChatId(convoId);
  setActiveDirectId(convoId);
  markConversationViewedBestEffort(convoId, currentUserId);

  if (autoCall) {
    setPendingCallUserId(targetUserId);
  }
};

const handleMessageUser = async (targetUserId) => {
  await openDirectConversation(targetUserId);
};

const handleCallUser = async (targetUserId) => {
  await openDirectConversation(targetUserId, { autoCall: true });
};


const selectedConvo = useMemo(
  () => dmConversations.find(c => c.id === currentChatId),
  [dmConversations, currentChatId]
);

const otherUser = useMemo(() => {
  if (!selectedConvo || !currentUser?.uid) return null;
  const otherUid = (selectedConvo.members || []).find(u => u !== currentUser.uid);
  if (!otherUid) return null;
  return {
    id: otherUid,
    firstInitialLastName: selectedConvo.memberProfiles?.[otherUid]?.firstInitialLastName || null,
    agency: selectedConvo.memberProfiles?.[otherUid]?.agency || null,
    rank: selectedConvo.memberProfiles?.[otherUid]?.rank || null,
    city: selectedConvo.memberProfiles?.[otherUid]?.city || null,
    stateProvince: selectedConvo.memberProfiles?.[otherUid]?.stateProvince || selectedConvo.memberProfiles?.[otherUid]?.state || null,
    country: selectedConvo.memberProfiles?.[otherUid]?.country || null,
    avatarUrl: selectedConvo.memberProfiles?.[otherUid]?.avatarUrl || null,
  };
}, [selectedConvo, currentUser?.uid]);


const handleViewProfile = (targetUserId) => {
  setOpenMenu({ listId: null, userId: null });
  setSearchUserMenuOpen(null);

  if (!targetUserId) {
    console.warn('⚠️ No user ID provided for profile view');
    return;
  }

  // Navigate to the user’s profile page
  navigate(`/profile/${targetUserId}`);
};



const handleAddToGroupFromList = async (user) => {
  setGroupSelectorUser(user); // 👤 this is the user you're trying to add
  setGroupsLoading(true);     // show loading spinner

  try {
    const groups = await fetchUserGroups(currentUser.uid); // 🔁 reuse your existing function
    setUserGroups(groups);
  } catch (err) {
    console.error('Error loading user groups:', err);
    setUserGroups([]);
  }

  setGroupsLoading(false);
  setShowGroupModal(true); // ✅ now open modal
};



	const fetchListsAndMembers = async () => {
  if (!currentUser?.uid) return;

  const lists = await getUserLists(currentUser.uid);

// ✅ Sort newest first
lists.sort((a, b) => {
  const aTime = a.createdAt?.seconds ? a.createdAt.seconds : new Date(a.createdAt).getTime();
  const bTime = b.createdAt?.seconds ? b.createdAt.seconds : new Date(b.createdAt).getTime();
  return bTime - aTime;
});

setUserLists(lists);



  const membersMap = {};

  for (const list of lists) {
    const memberIds = await getListMembers(currentUser.uid, list.id);
    const memberData = [];

    for (const userId of memberIds) {
      if (userId === currentUser.uid) continue; // skip self
      const userSnap = await getDoc(doc(db, 'users', userId));
      if (userSnap.exists()) {
        memberData.push({ id: userId, ...userSnap.data() });
      }
    }

    membersMap[list.id] = memberData;
  }

  setListMembers(membersMap);
};
	


	const menuRef = useRef();


useEffect(() => {
  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpenMenu(null);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);	




	const searchMenuRef = useRef(null);
useEffect(() => {
  const handleClickOutside = (e) => {
    if (searchMenuRef.current && !searchMenuRef.current.contains(e.target)) {
      setSearchUserMenuOpen(null);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);

useEffect(() => {
  const fetchDMUsers = async () => {
    if (activeDMUserIds.length === 0) {
      setActiveDMUsers([]);
      return;
    }

    const userDocs = await Promise.all(
      activeDMUserIds.map((id) => getDoc(doc(db, 'users', id)))
    );

    const userList = userDocs
      .filter((docSnap) => docSnap.exists())
      .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));

    setActiveDMUsers(userList);
  };

  fetchDMUsers();
}, [activeDMUserIds]);

	useEffect(() => {
  if (userId) {
    refreshGroupList();
  }
}, [userId]);



	useEffect(() => {
  if (!currentUser?.uid) return;

  const q = query(
    collection(db, 'conversations'),
    where('isGroup', '==', true),
    where('members', 'array-contains', currentUser.uid)
  );

  const unsubscribe = onSnapshot(q, async (snapshot) => {
  try {
  const updatedGroups = [];

  for (const docSnap of snapshot.docs) {
    const data = docSnap.data();
    const groupId = docSnap.id;

    const latestMessageTime = data.lastMessageAt
      ? (data.lastMessageAt.toDate ? data.lastMessageAt.toDate() : new Date(data.lastMessageAt))
      : null;

    const viewDocRef = doc(db, 'conversations', groupId, 'views', currentUser.uid);
    const viewDocSnap = await getDoc(viewDocRef);
    const lastViewed = viewDocSnap.exists() ? viewDocSnap.data().lastViewed?.toDate?.() : null;

    const lastSender = data.lastMessageSender || null;
    const hasUnread =
      lastViewed && latestMessageTime
        ? latestMessageTime > lastViewed && lastSender !== currentUser.uid
        : latestMessageTime && lastSender !== currentUser.uid;
        // 🟡 DEBUG: Log what each group sees
      console.log(
        `🟡 Group "${data.name}" → lastMessageAt:`,
        latestMessageTime,
        'lastViewed:',
        lastViewed,
        'lastSender:',
        lastSender,
        'hasUnread:',
        hasUnread
      );

    updatedGroups.push({
      id: groupId,
      ...data,
      hasUnread,
      createdAt: data.createdAt?.seconds
        ? new Date(data.createdAt.seconds * 1000)
        : new Date(data.createdAt),
    });
  }

  setGroups(updatedGroups.sort((a, b) => b.createdAt - a.createdAt));
  } catch (error) {
    console.error('Group snapshot processing error:', error);
  }
}, (error) => {
  console.error('Group list listener error:', error);
});

  return () => unsubscribe();
}, [currentUser?.uid]);
	



   const auth = getAuth();
   const chatEndRef = useRef(null);
   



  useEffect(() => {
  console.log('Current chat ID:', currentChatId);
  if (!currentChatId) return;

	console.log('📡 Listening to messages for:', currentChatId);

  const q = collection(db, 'conversations', currentChatId, 'messages');
  const unsubscribe = onSnapshot(q, (snapshot) => {
    const msgs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setMessages(msgs);
  }, (error) => {
    console.error('Conversation messages listener error:', error);
  });

  return () => unsubscribe();
}, [currentChatId]);


  useEffect(() => {
  if (chatEndRef.current) {
    chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }
}, [messages]);



  useEffect(() => {
  const me = currentUser?.uid;
  if (!me) return;

  const q = query(
    collection(db, 'conversations'),
    where('isGroup', '==', false),
    where('members', 'array-contains', me),
    orderBy('lastMessageAt', 'desc')
  );

  const unsub = onSnapshot(q, async (snap) => {
    const items = [];

    for (const docSnap of snap.docs) {
      const data = docSnap.data();

      // compute unread for me
      let hasUnread = false;
      try {
        const viewRef = doc(db, 'conversations', docSnap.id, 'views', me);
        const viewSnap = await getDoc(viewRef);
        const lastViewed = viewSnap.exists() ? viewSnap.data().lastViewed?.toDate?.() : null;
        const lastMessageAt = data.lastMessageAt?.toDate?.();
        const lastSender = data.lastMessageSender;
        const lastCallLogAt = data.lastCallLogAt?.toDate?.();
        const lastCallLogType = data.lastCallLogType;
        const lastCallLogBy = data.lastCallLogBy;

        const messageUnread = !!(
          docSnap.id !== currentChatId &&
          lastMessageAt &&
          (!lastViewed || lastMessageAt > lastViewed) &&
          lastSender !== me
        );

        const missedCallUnread = !!(
          docSnap.id !== currentChatId &&
          lastCallLogType === 'missed' &&
          lastCallLogBy &&
          lastCallLogBy !== me &&
          lastCallLogAt &&
          (!lastViewed || lastCallLogAt > lastViewed)
        );

        hasUnread = messageUnread || missedCallUnread;
      } catch (e) {
        // ignore
      }

      const otherUid = Array.isArray(data.members) ? data.members.find(uid => uid !== me) : null;
      let memberProfiles = data.memberProfiles || {};

      if (otherUid) {
        const profile = memberProfiles[otherUid] || {};
        if (!profile.city && !profile.stateProvince && !profile.state && !profile.country) {
          try {
            const userSnap = await getDoc(doc(db, 'users', otherUid));
            if (userSnap.exists()) {
              const userData = userSnap.data();
              memberProfiles = {
                ...memberProfiles,
                [otherUid]: {
                  ...profile,
                  firstInitialLastName: profile.firstInitialLastName || userData.firstInitialLastName || null,
                  agency: profile.agency || userData.agency || null,
                  rank: profile.rank || userData.rank || null,
                  city: userData.city || null,
                  stateProvince: userData.stateProvince || userData.state || null,
                  country: userData.country || null,
                  avatarUrl: profile.avatarUrl || userData.avatarUrl || null,
                },
              };
            }
          } catch (e) {
            // Keep the conversation row usable if the profile lookup fails.
          }
        }
      }

      items.push({ id: docSnap.id, ...data, memberProfiles, hasUnread });
    }

    // dedupe by dmKey or sorted members; keep newest by lastMessageAt
    const map = new Map();
    for (const c of items) {
      const key = c.dmKey || (Array.isArray(c.members) ? [...c.members].sort().join('_') : c.id);
      const prev = map.get(key);
      if (!prev) {
        map.set(key, c);
      } else {
        const a = c.lastMessageAt?.seconds || 0;
        const b = prev.lastMessageAt?.seconds || 0;
        map.set(key, a > b ? c : prev);
      }
    }

    setDmConversations([...map.values()]);
  }, (error) => {
    console.error('DM list listener error:', error);
  });

  return () => unsub();
}, [currentUser?.uid, currentChatId]);



// 👁️ Listen for updates in *my* view documents across all groups
useEffect(() => {
  return undefined;

  const q = query(
    collection(db, '__disabled_views_listener__'),
    where('userId', '==', currentUser.uid)
  );

  const unsub = onSnapshot(q, () => {
    console.log('👁️ View doc changed → refreshing group list');
    refreshGroupList();
  });

  return () => unsub();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentUser?.uid]);



useEffect(() => {
  if (currentUser?.uid) {
    fetchListsAndMembers();
  }
}, [currentUser?.uid]);



	const handleSaveListName = async (listId) => {
  if (!editedListName.trim()) return;
  try {
    const listRef = doc(db, 'users', currentUser.uid, 'userLists', listId);
    await updateDoc(listRef, { name: editedListName.trim() });
    toast.success('List name updated.');
    setEditingListId(null);
    await fetchListsAndMembers();
  } catch (err) {
    console.error('Failed to update list name:', err);
    toast.error('Error saving list name.');
  }
};

const handleDeleteList = async (listId) => {
  showConfirmToast('Are you sure you want to delete this list?', async () => {
    try {
      // Delete the list doc
      const listRef = doc(db, 'users', currentUser.uid, 'userLists', listId);
      await deleteDoc(listRef);

      // Delete the members subcollection
      const membersSnap = await getDocs(collection(listRef, 'members'));
      const deletePromises = membersSnap.docs.map((doc) => deleteDoc(doc.ref));
      await Promise.all(deletePromises);

      toast.success('List deleted.');
      await fetchListsAndMembers();
    } catch (err) {
      console.error('Failed to delete list:', err);
      toast.error('Error deleting list.');
    }
  });
};



  const filteredUsers = users.filter((user) => {
    const name = [
      user.firstInitialLastName,
      user.firstName,
      user.lastName,
      user.country,
      user.stateProvince || user.state,
      user.city,
    ].filter(Boolean).join(' ').toLowerCase();
    const matchesSearch = name.includes(searchTerm.toLowerCase());
    return matchesSearch;
  });


  const toggleUserSelection = (userId) => {
    setSelectedUserIds((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };



  const handleCreateGroup = async () => {
  console.log('Create button clicked');

  if (!newGroupName.trim()) {
    console.warn('Group name is empty');
    return;
  }

  const allMembers = [...new Set([userId, ...selectedUserIds.filter(Boolean)])];


const newGroup = {
  name: newGroupName.trim(),
  members: allMembers,
  createdBy: userId,
  adminIds: [userId],
  createdAt: new Date().toISOString(),
  isGroup: true
};

  try {
    const groupId = await createGroupInFirestore(newGroup);
    setGroups([...groups, { id: groupId, ...newGroup }]);
    setNewGroupName('');
    setSelectedUserIds([]);
    setShowCreateGroupModal(false);
    await refreshGroupList(); // ✅ Refresh view
    console.log('Group created successfully');
  } catch (error) {
    console.error('Failed to create group:', error);
  }
};




const refreshActiveDMs = async () => {
  if (!currentUser?.uid) return;

  try {
    const q = query(
      collection(db, 'conversations'),
      where('isGroup', '==', false),
      where('members', 'array-contains', currentUser.uid)
    );

    const snapshot = await getDocs(q);
    const ids = [];
    const unreadMap = {};

    for (const docSnap of snapshot.docs) {
      const data = docSnap.data();
      const convoId = docSnap.id;
      const otherUserId = data.members?.find(id => id !== currentUser.uid);
      if (!otherUserId) continue;

      ids.push(otherUserId);

      const viewRef = doc(db, 'conversations', convoId, 'views', currentUser.uid);
      const viewSnap = await getDoc(viewRef);
      const lastViewed = viewSnap.exists() ? viewSnap.data().lastViewed?.toDate?.() : null;

      // 🔍 Fetch most recent message
      const messagesRef = collection(db, 'conversations', convoId, 'messages');
      const lastMsgQuery = query(
        messagesRef,
        where('deleted', '==', false),
        orderBy('createdAt', 'desc')
      );
      const messagesSnap = await getDocs(lastMsgQuery);
      const lastDoc = messagesSnap.docs[0];

      if (!lastDoc) {
        unreadMap[otherUserId] = false;
        continue;
      }

      const lastMessage = lastDoc.data();
      const isUnread =
        lastMessage.senderId !== currentUser.uid &&
        (!lastViewed || lastMessage.createdAt?.toDate() > lastViewed);

      unreadMap[otherUserId] = isUnread;
    }

    setActiveDMUserIds(ids);
    setDmUnreadMap(unreadMap);
  } catch (err) {
    console.error('Failed to refresh DM list:', err);
  }
};

const handleCreateList = async () => {
  const trimmedName = newListName.trim();
  if (!trimmedName) return;

  try {
    const currentUserId = auth.currentUser?.uid;
    if (!currentUserId) return;

    const newListRef = doc(collection(db, 'users', currentUserId, 'userLists'));
await setDoc(newListRef, {
  name: trimmedName,
  createdAt: new Date(),
});

    // Update local state immediately
    setUserLists(prev => [...prev, { id: newListRef.id, name: trimmedName }]);
    setNewListName('');
    setShowCreateListModal(false);
    await fetchListsAndMembers();
  } catch (err) {
    console.error('❌ Failed to create list:', err);
  }
};



	const handleAddUserToExistingGroup = async (groupId, userIdToAdd) => {
  try {
    const groupRef = doc(db, 'conversations', groupId);
    await updateDoc(groupRef, {
      members: arrayUnion(userIdToAdd),
    });
    toast.success('User added to group.');
    setShowGroupModal(false);
  } catch (err) {
    console.error('Failed to add user to group:', err);
    toast.error('Error adding user.');
  }
};



	const fetchUserGroups = async (userId) => {
  const q = query(
    collection(db, 'conversations'),
    where('isGroup', '==', true),
    where('members', 'array-contains', userId)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};




	const handleAddUsersToExistingGroup = async (groupId, userIdsToAdd) => {
  try {
    const groupRef = doc(db, 'conversations', groupId);
    await updateDoc(groupRef, {
      members: arrayUnion(...userIdsToAdd),
    });
    toast.success('Users added to group.');
    setShowGroupModal(false);
  } catch (err) {
    console.error('Failed to add users to group:', err);
    toast.error('Error adding users.');
  }
};



	const openGroupSelectorForSelectedUsers = async () => {
  setGroupsLoading(true);
  const allGroups = await fetchUserGroups(currentUser.uid);
  setUserGroups(allGroups);
  setGroupsLoading(false);
  setShowGroupModal(true);
};





  return (
     <>
  {activeGroupId ? (
  <GroupChat
    currentUser={currentUser}
    groupId={activeGroupId}
    onBack={() => setActiveGroupId(null)}
    refreshGroupList={refreshGroupList}
  />
) : activeDirectId ? (
  <DirectChat
    chatId={currentChatId}
    currentUser={currentUser}
    otherUser={otherUser}
    autoCallTarget={pendingCallUserId}
    onAutoCallConsumed={() => setPendingCallUserId(null)}
    onBack={(state = null) => {
      setActiveDirectId(null);
      setCurrentChatId(null);
      setPendingCallUserId(null);
      if (state?.convoDeleted) {
        toast.info('This conversation was deleted by the other user.');
      }
    }}
  />

) : (

  <div className="messaging-page"> 

  <div className="page-info-header-block messaging-topbar">
    <h2>Messaging</h2>
    <div className="page-info-button-wrapper">
      <PageInfoButton title="About Messaging">
        <p>
          Tap the search button (magnifying glass) and pick any filters you want. You can combine
          multiple filters and the results will appear right under the search button; the three-dot menu
          next to each name holds the interaction options.
        </p>
        <ul className="page-info-list">
          <li>
            <strong>Groups:</strong> The Groups section is collapsible. When open, use Create Group to
            start a new room. Add members from the search results via each user's three-dot menu, or from the three-dot menu inside the group. Members can leave the group at any time. Group creators and admins can remove members or delete the group.
          </li>
          <li>
            <strong>Direct conversations:</strong> Recent direct chats appear in the list.
            Tap a name to jump straight into the conversation.
          </li>
	  <li>
            <strong>Voice Calls:</strong> Start a voice call with another user by tapping the 			call button in the top-right corner  inside a conversation thread.
          </li>
          <li>
            <strong>My Contact Lists:</strong> Create a custom list, then save users into it for quick access.
            Users can be added through the search results at the top of the page once the list exists.
          </li>
        </ul>
      </PageInfoButton>
    </div>
  </div>

  <div className="messaging-info">
    <div className="messaging-info-logo-panel" aria-hidden="true">
      <img src="/coldwire-messaging-logo.png" alt="" className="messaging-info-logo" />
    </div>
    <div className="messaging-info-list">
      <div className="messaging-info-item">
        <span className="messaging-info-icon messaging-info-icon-search" aria-hidden="true" />
        <span>Find cold case investigators across agencies, jurisdictions, and countries.</span>
      </div>
      <div className="messaging-info-item">
        <span className="messaging-info-icon messaging-info-icon-message" aria-hidden="true" />
        <span>Connect directly to share leads, compare case details, or request assistance.</span>
      </div>
      <div className="messaging-info-item">
        <span className="messaging-info-icon messaging-info-icon-group" aria-hidden="true" />
        <span>Create and save collaboration groups for investigations, case reviews, or long-term projects.</span>
      </div>
      <div className="messaging-info-item">
        <span className="messaging-info-icon messaging-info-icon-bookmark" aria-hidden="true" />
        <span>Save contacts in custom lists for quick access.</span>
      </div>
    </div>
  </div>

  <div className="messaging-info messaging-info-legacy">
    • Search for cold case investigators across agencies, jurisdictions, and countries.<br />
    • Connect directly to share leads, compare case details, or request assistance.<br />
    • Create and save collaboration groups for active investigations, case reviews, or long-term projects.<br />
    • Save contacts in custom lists for quick access.
  </div>

 
      <div className="messaging-search-controls">
        <div className="messaging-search-info-row">
          <button
            className="info-icon messaging-search-help-button"
            onClick={() => setShowSearchInfo(!showSearchInfo)}
            title="How to use search"
            aria-label="How to use search"
            type="button"
          >
            ℹ️
          </button>
        </div>
  <button
className="messaging-search-launch-button"
    onClick={() => {
      setSearchFields({});
      setDirectoryFilters({});
      setDirectoryOptions({});
      setOpenDirectoryField(null);
      setSearchResults([]);
      setSearchNoteMap({});
      setOpenSearchNoteId(null);
      setSelectedListId(null);
      setShowSearchModal(true);
    }}
    title="Open advanced search"
    type="button"
  >
    <span>🔍 Search investigators</span>
    <span className="messaging-search-arrow" aria-hidden="true">›</span>
  </button>
</div>

  {showSearchInfo && (
  <div
    ref={infoBoxRef}
    className="messaging-search-info-panel"
  >
    <strong>Search Tips:</strong>
    <ul>
      <li>Use country, state/province, city, or last name filters to find ColdWire members.</li>
      <li>Type in a dropdown to narrow alphabetical options, then select the matching value.</li>
      <li>You can combine filters to narrow the results.</li>
    </ul>
  </div>
)}



{showSearchModal && (
  <div className="modal-overlay" onClick={() => setShowSearchModal(false)}>
  <div className="search-modal-content" onClick={(e) => e.stopPropagation()}>
    <div className="search-field-row">
      <label>
        Search by:
        <select
          onChange={(e) => handleAddSearchField(e.target.value)}
          value=""
          style={{ marginLeft: '8px' }}
        >
          <option value="">Select filters</option>
          {Object.entries(DIRECTORY_SEARCH_FIELDS)
            .filter(([field]) => !searchFields.hasOwnProperty(field))
            .map(([field, config]) => (
              <option key={field} value={field}>{config.label}</option>
            ))}
        </select>
      </label>
    </div>

    {Object.entries(searchFields).map(([field, value]) => {
      const config = DIRECTORY_SEARCH_FIELDS[field];
      const options = directoryOptions[field] || [];
      const filter = directoryFilters[field] || '';
      return (
        <div key={field} className="search-field-row">
          <div className="search-field-heading">
            <div className="search-field-label">{config?.label || field}</div>
            <button
              type="button"
              onClick={() => handleRemoveSearchField(field)}
              className="search-field-remove"
              title="Remove filter"
              aria-label={`Remove ${config?.label || field} filter`}
            >
              X
            </button>
          </div>

          <div className="agency-select-panel">
            <input
              type="text"
              value={filter}
              onChange={(e) => {
                const nextFilter = e.target.value;
                setDirectoryFilters((prev) => ({ ...prev, [field]: nextFilter }));
                void loadDirectoryOptions(field, nextFilter);
              }}
              placeholder={config?.placeholder || 'Type to filter...'}
              className="agency-select-filter"
            />
            <div className="agency-select-options">
              {options.map((option) => (
                <button
                  key={option.id}
                  type="button"
                  className={'agency-select-option' + (option.id === value?.id ? ' selected' : '')}
                  onClick={() => {
                    setSearchFields((prev) => ({ ...prev, [field]: option }));
                    setDirectoryFilters((prev) => ({
                      ...prev,
                      [field]: getOptionLabel(option),
                    }));
                  }}
                >
                  {getOptionLabel(option)}
                </button>
              ))}
              {options.length === 0 && (
                <div className="agency-select-empty">No options found</div>
              )}
            </div>
          </div>
        </div>
      );
    })}

    <div className="search-modal-buttons">
      <button className="search-modal-submit-btn" onClick={handleRunSearch}>Search</button>
      <button className="search-modal-close-btn" onClick={() => setShowSearchModal(false)}>Close</button>
    </div>
  </div>
  </div>
)}


{hasSearched && searchResults && (
  <div className="search-results" style={{ padding: '16px' }}>
    <h4>Search Results</h4>

    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginBottom: '12px',
        gap: '12px',
      }}
    >
      <label style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={selectAllResults}
          onChange={() => {
            const allIds = searchResults.map((u) => u.id);
            if (selectAllResults) {
              setSelectedSearchUserIds([]);
            } else {
              setSelectedSearchUserIds(allIds);
            }
            setSelectAllResults(!selectAllResults);
          }}
          style={{ marginRight: '6px' }}
        />
        Select All
      </label>

     {selectedSearchUserIds.length > 0 && (
  <>
   <button
  onClick={() => {
    if (!addingToListLoading) {   // prevent spam clicks
      setUserToAddToList(null);
      setSearchContext({ mode: 'addToListBulk' });
      setShowSingleAddModal(true);
    }
  }}
  disabled={addingToListLoading}
  style={{
    backgroundColor: addingToListLoading ? '#ccc' : '#007bff',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    cursor: addingToListLoading ? 'not-allowed' : 'pointer',
    opacity: addingToListLoading ? 0.7 : 1,
  }}
>
  {addingToListLoading ? 'Adding...' : '+ Add to List'}
</button>


   <button
  onClick={openGroupSelectorForSelectedUsers}
  style={{
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
  }}
>
  + Add to Group
</button>

  </>
)}

</div>
 

    {searchResults.length === 0 ? (
      <p style={{ color: '#888' }}>No users matched your search criteria.</p>
    ) : (
      searchResults.map((user) => {
        const privateNote = searchNoteMap[user.id];
        return (
  <div
    key={user.id}
    className="user-list-item"
    style={{
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      borderBottom: '1px solid #eee',
    }}
  >
    <input
      type="checkbox"
      style={{ marginRight: '10px' }}
      checked={selectedSearchUserIds.includes(user.id)}
      onChange={() => {
        setSelectedSearchUserIds((prev) =>
          prev.includes(user.id)
            ? prev.filter((id) => id !== user.id)
            : [...prev, user.id]
        );
      }}
    />

   <span>
  <strong>
    {user.fullName || `${user.firstName?.[0] || ''}.${user.lastName || 'Unknown'}`}
  </strong>
  {' '}
  {[user.city, user.stateProvince || user.state, user.country]
    .filter(Boolean)
    .join(', ') || 'Location not provided'}
  {user.isFederal && (
    <span className="fed-badge" title="Federal employee">F</span>
  )}
  {privateNote && (
    <button
      className="search-private-note-button"
      onClick={(event) => {
        event.stopPropagation();
        setOpenSearchNoteId((prev) => (prev === user.id ? null : user.id));
        setSearchUserMenuOpen(null);
      }}
      title="View private note"
      aria-label="View private note"
      type="button"
    >
      📝
    </button>
  )}
</span>


    <div style={{ marginLeft: 'auto', position: 'relative' }}>
      <button
        onClick={() =>
          setSearchUserMenuOpen((prev) => (prev === user.id ? null : user.id))
        }
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '26px',
        }}
      >
        ⋮
      </button>

    {searchUserMenuOpen === user.id && (
  <div className="user-menu" ref={searchMenuRef}>
    <div className="user-menu-item" onClick={() => handleMessageUser(user.id)}>
      Message
    </div>

{/* CALL BUTTON in search results- 
    <div className="user-menu-item" onClick={() => handleCallUser(user.id)}>
      Call
    </div>
*/}
    <div
      className="user-menu-item"
      onClick={() => {
        setUserToAddToList(user);
        setShowSingleAddModal(true);
        setSearchUserMenuOpen(null);
      }}
    >
      Add to List
    </div>
    <div
      className="user-menu-item"
      onClick={() => handleAddToGroupFromList(user)}
    >
      Add to Group
    </div>
    <div className="user-menu-item" onClick={() => handleViewProfile(user.id)}>
      View Profile
    </div>
  </div>
)}

      {privateNote && openSearchNoteId === user.id && (
        <div className="search-private-note-popover">
          <div className="search-private-note-popover-header">
            <strong>Private Note</strong>
            <button
              onClick={() => setOpenSearchNoteId(null)}
              aria-label="Close private note"
              type="button"
            >
              x
            </button>
          </div>
          <p>{privateNote.text}</p>
          <button
            className="search-private-note-profile-link"
            onClick={() => handleViewProfile(user.id)}
            type="button"
          >
            View Profile to Edit
          </button>
        </div>
      )}

    </div>
  </div>
);
})

    )}
  </div>
)}

      <div className={`group-section${showCreateGroupModal ? ' group-section-modal-open' : ''}`}>

	<div className="group-header" onClick={() => setShowGroups(!showGroups)}>
  <span className="section-title-icon section-title-icon-groups" aria-hidden="true" />
  <button
    className="create-group-button group-header-create-button"
    onClick={(e) => {
      e.stopPropagation();
      setShowCreateGroupModal(true);
    }}
    type="button"
  >
    + Create Group
  </button>
  <span className="group-label">Groups {showGroups ? '▲' : '▼'}</span>
</div>

	{showCreateGroupModal && (
 <div className="create-group-inline-modal">
 <div
  className="modal-content create-group-modal-content"
  onClick={(e) => e.stopPropagation()}
  style={{
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    maxWidth: '400px',
    width: '100%',
    boxShadow: '0 0 10px rgba(0,0,0,0.3)',
  }}
>
  <h3 style={{ marginBottom: '12px' }}>Create New Group</h3>

  <input
    type="text"
    placeholder="Enter group name"
    value={newGroupName}
    onChange={(e) => setNewGroupName(e.target.value)}
    style={{
      width: '100%',
      padding: '8px',
      marginBottom: '12px',
      borderRadius: '4px',
      border: '1px solid #ccc'
    }}
  />

  <div style={{ maxHeight: '200px', overflowY: 'auto', marginBottom: '12px' }}>
    {users.length === 0 ? (
      <p style={{ color: '#888' }}>No users available.</p>
    ) : (
      users.map(user => (
        <label key={user.id} style={{ display: 'block', marginBottom: '4px' }}>
          <input
            type="checkbox"
            checked={selectedUserIds.includes(user.id)}
            onChange={() => toggleUserSelection(user.id)}
            style={{ marginRight: '6px' }}
          />
          {user.rank || ''} {user.firstInitialLastName || user.email}
        </label>
      ))
    )}
  </div>

  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
    <button
      onClick={() => setShowCreateGroupModal(false)}
      style={{
        marginRight: '8px',
        padding: '6px 10px',
        border: 'none',
        borderRadius: '4px',
        backgroundColor: '#ccc',
        color: '#333'
      }}
    >
      Cancel
    </button>
    <button
      onClick={handleCreateGroup}
      style={{
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        backgroundColor: '#007bff',
        color: 'white'
      }}
    >
      Create
    </button>
  </div>
</div>
</div>
)}

        {showGroups && (
          <div className="group-list">
     {groups.map((group) => (
  <div
    className="group-item"
    key={group.id}
   onClick={async () => {
  console.log('Opening group:', group.id);
  const groupConversationRef = doc(db, 'conversations', group.id);

  try {
    const docSnap = await getDoc(groupConversationRef);
    if (!docSnap.exists()) {
      await setDoc(groupConversationRef, {
        name: group.name,
        isGroup: true,
        members: group.members,
        createdAt: new Date(),
      });
      console.log('Group conversation initialized.');
    }

    // ✅ Mark as viewed only when user *enters* the conversation
    if (currentUser?.uid) {
      markConversationViewedBestEffort(group.id, currentUser.uid);
      console.log(`👁️ Marked group ${group.name} as viewed`);
    }

    navigate(`/group/${group.id}`, { state: { currentUser } });


    // ✅ Trigger local refresh (dot should clear instantly)
    await refreshGroupList();
  } catch (err) {
    console.error('Error initializing group conversation:', err);
  }
}}
    style={{ cursor: 'pointer' }}
  >
   <h3>
  <span className="group-row-copy">
    <span className="group-row-title">{localGroupNames[group.id] || group.name}</span>
    <span className="group-row-meta">
      {Array.isArray(group.members) ? `${group.members.length} ${group.members.length === 1 ? 'member' : 'members'}` : 'Group chat'}
      <span aria-hidden="true"> · </span>
    </span>
  </span>
  {group.hasUnread && <span className="unread-dot" />}
  <span className="row-chevron" aria-hidden="true">›</span>
</h3>


  </div>
))}

            <button className="create-group-button" onClick={() => setShowCreateGroupModal(true)}
>
              + Create Group
            </button>
          </div>
        )}
      </div>

	{showSingleAddModal && (
  <div
    className="modal-overlay"
    onClick={() => setShowSingleAddModal(false)}
    style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999
    }}
  >
    <div
      className="modal-content"
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
      }}
    >
      <h3>Select List</h3>
      {userLists.length === 0 ? (
        <p style={{ color: '#888' }}>You don’t have any lists yet.</p>
      ) : (
        userLists.map((list) => (
          <div
            key={list.id}
            onClick={async () => {
		     // ✅ Set loading state for this list
     			if (addingToListId) return; // prevent multiple simultaneous clicks
     			setAddingToListId(list.id);
              try {
         if (userToAddToList) {
  const added = await handleAddUserToList(userToAddToList.id, list.id);
  if (added) {
    await fetchListsAndMembers(); // ✅ refresh list UI
    toast.success(`Added to "${list.name}"`);
  } else {
    toast.info('User is already in this list.');
  }
}
 else {
        let addedCount = 0;
        let skippedCount = 0;

for (const uid of selectedSearchUserIds) {
  const added = await handleAddUserToList(uid, list.id);
  if (added) {
    addedCount++;
  } else {
    skippedCount++;
  }
}

  await fetchListsAndMembers();

if (addedCount > 0) {
  toast.success(`Added ${addedCount} user(s) to "${list.name}"`);
}
if (skippedCount > 0 && addedCount === 0) {
  toast.info('All selected users are already in this list.');
}

setSelectedSearchUserIds([]);
setSelectAllResults(false);

                  setSelectedSearchUserIds([]);
                  setSelectAllResults(false);
                }

                setShowSingleAddModal(false);
              } catch (err) {
                console.error('Failed to add user(s) to list:', err);
                toast.error('Failed to add.');
              } finally {
		   setAddingToListId(null); // ✅ Reset loading state
	             }
            }}
            style={{
              padding: '8px 0',
              borderBottom: '1px solid #eee',
              cursor: addingToListId === list.id ? 'not-allowed' : 'pointer',
	                color: addingToListId === list.id ? '#999' : '#007bff',
     				  opacity: addingToListId === list.id ? 0.6 : 1
            }}
          >
            {addingToListId === list.id ? '⏳ Adding…' : list.name}
          </div>
        ))
      )}

      <div style={{ textAlign: 'right', marginTop: '12px' }}>
        <button onClick={() => setShowSingleAddModal(false)}>Cancel</button>
      </div>
    </div>
  </div>
)}




<div className="dm-section">
  <div className="dm-header">
    <span className="section-title-icon section-title-icon-dm" aria-hidden="true" />
    <span>Direct Messages</span>
  </div>

  {dmConversations.length === 0 ? (
    <p style={{ padding: '8px 12px', color: '#999' }}>No conversations yet.</p>
  ) : (
    <>
      {dmConversations.map((c) => {
        const myUid = currentUser?.uid;
        const otherUid = Array.isArray(c.members) ? c.members.find(u => u !== myUid) : null;
        const profile = c.memberProfiles?.[otherUid] || {};
        const name = profile.firstInitialLastName || 'Unknown';
        const locationLabel = getLocationLabel(profile);

        return (
          <div
            key={c.id}
            className="user-item"
            onClick={async () => {
              const resolvedConvoId = otherUid
                ? await ensureDirectConversation(otherUid)
                : c.id;

              if (!resolvedConvoId) {
                return;
              }

              markConversationViewedBestEffort(resolvedConvoId, myUid);
              navigate(`/direct/${resolvedConvoId}`);

            }}
            style={{ position: 'relative', cursor: 'pointer' }}
          >
            <span className="dm-row-copy">
              <span className="dm-row-name">{name}</span>
              <span className="dm-row-meta">{locationLabel}</span>
            </span>
            {c.hasUnread && <span className="unread-dot" />}
            <span className="row-chevron" aria-hidden="true">›</span>
          </div>
        );
      })}
    </>
  )}
</div>



<div className="custom-lists-header">
  <h3>
    <span className="section-title-icon section-title-icon-lists" aria-hidden="true" />
    <span>My Contact Lists</span>
  </h3>
  <button
    onClick={() => setShowCreateListModal(true)}
    className="create-list-button"
  >
    + Create New List
  </button>
</div>
<div className="custom-lists-section">
  {userLists.map((list) => (
  <div key={list.id} className="user-list-block">
  <div className="list-header">
    <span className="list-folder-icon" aria-hidden="true" />
    <h4
      onClick={() =>
        setExpandedListId((prevId) => (prevId === list.id ? null : list.id))
      }
      style={{
        marginBottom: '8px',
        cursor: 'pointer',
        color: '#007bff',
        textDecoration: 'none',
      }}
    >
      {editingListId === list.id ? (
        <input
          type="text"
          value={editedListName}
          onChange={(e) => setEditedListName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSaveListName(list.id);
          }}
          style={{ fontSize: '1rem' }}
        />
      ) : (
        <>
          <span className="list-row-name">{list.name}</span>
          <span className="list-row-count">
            {listMembers[list.id]?.length || 0} contacts
          </span>
        </>
      )}
    </h4>

    <div className="list-actions">
      {editingListId === list.id ? (
        <button onClick={() => handleSaveListName(list.id)}>Save</button>
      ) : (
        <button onClick={() => {
          setEditedListName(list.name);
          setEditingListId(list.id);
        }}>
          ✏️
        </button>
      )}

      <button onClick={() => handleDeleteList(list.id)}>🗑️</button>
    </div>
  </div>

  {expandedListId === list.id && (
    <>
      {listMembers[list.id]?.length > 0 ? (
        <ul className="list-users" style={{ paddingLeft: '16px' }}>
          {listMembers[list.id].map((u) => (
           <li key={u.id} className="list-user">

                <div>
  <div>{u.firstInitialLastName || u.displayId || u.email}</div>
  <div className="list-user-location">
    {getLocationLabel(u)}
  </div>
</div>

                <div className="user-actions">

                 <button
  onClick={() =>
    setOpenMenu((prev) =>
      prev?.listId === list.id && prev?.userId === u.id
        ? null
        : { listId: list.id, userId: u.id }
    )
  }
  style={{
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '26px',
  }}
>
  ...
</button>


                {openMenu?.listId === list.id && openMenu?.userId === u.id && (
  <div ref={menuRef} className="user-menu show">
    <div
      className="user-menu-item"
      onClick={() => {
        handleMessageUser(u.id);
        setOpenMenu(null);
      }}
    >
      Message
    </div>

{/* CALL BUTTON in the custom lists
    <div
      className="user-menu-item"
      onClick={() => {
        handleCallUser(u.id);
        setOpenMenu(null);
      }}
    >
      Call
    </div>
	*/}
    <div
      className="user-menu-item"
      onClick={() => {
        handleViewProfile(u.id);
        setOpenMenu(null);
      }}
    >
      View Profile
    </div>
    <div
      className="user-menu-item"
     onClick={() => {
  handleRemoveUserFromList(u.id, list.id);
  setOpenMenu(null);
}}

    >
      Remove from List
    </div>
  </div>
)}




                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p
            style={{
              fontSize: '0.9rem',
              color: '#888',
              paddingLeft: '16px',
              marginTop: '4px',
            }}
          >
            No users added yet.
          </p>
        )}
      </>
    )}
  </div>
))}
</div>

   {showCreateListModal && (
  <div
    className="modal-overlay"
    onClick={() => setShowCreateListModal(false)}
    style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999
    }}
  >
    <div
      className="modal-content create-list-modal-content"
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
      }}
    >
      <h3 style={{ marginBottom: '12px' }}>Create New List</h3>
      <input
        type="text"
        placeholder="Enter list name"
        value={newListName}
        onChange={(e) => setNewListName(e.target.value)}
        style={{
          width: '100%',
          padding: '8px',
          marginBottom: '12px',
          borderRadius: '4px',
          border: '1px solid #ccc'
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button
          onClick={() => setShowCreateListModal(false)}
          style={{
            marginRight: '8px',
            padding: '6px 10px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: '#ccc',
            color: '#333'
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleCreateList}
          style={{
            padding: '6px 12px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: '#007bff',
            color: 'white'
          }}
        >
          Create
        </button>
      </div>
    </div>
  </div>
)}


      {showGroupModal && (
  <div className="group-modal-overlay">
    <div className="group-modal">
      <h3>Select Group to Add Member</h3>

      {groupsLoading ? (
        <p>Loading groups...</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {userGroups.map((group) => {
  const usersToCheck = groupSelectorUser
    ? [groupSelectorUser.id]
    : selectedSearchUserIds;

  const someUsersNotInGroup = usersToCheck.some(uid =>
    !group.members.includes(uid)
  );

  return (
    <li
      key={group.id}
      style={{
        padding: '8px',
        cursor: someUsersNotInGroup ? 'pointer' : 'not-allowed',
        color: someUsersNotInGroup ? '#000' : '#999',
        backgroundColor: '#f9f9f9',
        marginBottom: '6px',
        borderRadius: '4px',
      }}
      onClick={() => {
        if (someUsersNotInGroup) {
          if (groupSelectorUser) {
            handleAddUserToExistingGroup(group.id, groupSelectorUser.id);
          } else {
            const usersToActuallyAdd = selectedSearchUserIds.filter(
              uid => !group.members.includes(uid)
            );
            handleAddUsersToExistingGroup(group.id, usersToActuallyAdd);
          }
        }
      }}
    >
      {group.name}
      {!someUsersNotInGroup && ' (All selected already in group)'}
   				 </li>
 				 );
	   })}
        </ul>
      )}

      <div className="group-modal-actions" style={{ marginTop: '12px' }}>
        <button onClick={() => setShowGroupModal(false)}>Close</button>
 										     </div>
   									 </div>
 								 </div>
			)} 
        <ToastContainer />
       </div>
    )}
  </>
);
}

export default Messaging;
